import React from 'react';
import { documentDefinition } from '../../types/Search';
import TooltipContent from '../layout/TooltipContent';
import { Button, Modal } from 'react-bootstrap';

export interface Props {
    show: boolean;
    handleShow: any;
    handleClose: any;
    data: documentDefinition;
}

export const ImageModal: React.FC<Props> = (props) => {
    return (
        <>
            {props.data != undefined && (
                <Modal
                    show={props.show}
                    onHide={props.handleClose}
                    animation={false}
                    className='image-info-popup'
                >
                    <Modal.Header closeButton={true} closeLabel='close' onHide={props.handleClose}>
                        <Modal.Title>Image Info</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <TooltipContent data={props.data} large={true}></TooltipContent>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant='primary' onClick={props.handleClose}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            )}
        </>
    );
};

export default ImageModal;
